import { Link } from "react-router-dom";
import { castList } from "@/utils/catalog";

export default function FeaturedCast() {
  const featured = castList.slice(0, 8);

  return (
    <section className="bg-background-100 py-14">
      <div className="mx-auto w-full max-w-[1280px] px-4 md:px-6">
        <div className="mb-8 flex flex-wrap items-end justify-between gap-3">
          <div>
            <h2 className="font-heading text-2xl font-semibold text-foreground-900">精选演员阵容</h2>
            <p className="mt-2 text-sm text-foreground-500">台前每一位演员，都是角色的一部分。</p>
          </div>
          <Link
            to="/category/cast"
            className="inline-flex items-center gap-1 text-sm text-primary-600 transition hover:text-primary-700"
          >
            查看全部演员<i className="ri-arrow-right-s-line"></i>
          </Link>
        </div>

        <div className="grid grid-cols-2 gap-4 sm:grid-cols-3 lg:grid-cols-4">
          {featured.map((cast) => (
            <Link
              key={cast.id}
              to={`/detail/cast/${cast.id}`}
              className="group flex items-center gap-3 rounded-lg border border-background-200/70 bg-background-50 p-3 transition hover:border-primary-300"
            >
              <div className="h-14 w-14 flex-shrink-0 overflow-hidden rounded-full bg-background-100">
                <img
                  src={cast.avatar}
                  alt={`${cast.name}头像`}
                  title={`${cast.name} 演员资料`}
                  className="h-full w-full object-cover object-top transition duration-500 group-hover:scale-105"
                />
              </div>
              <div className="min-w-0">
                <p className="truncate text-sm font-medium text-foreground-900 transition group-hover:text-primary-600">
                  {cast.name}
                </p>
                <p className="mt-0.5 truncate text-xs text-foreground-500">饰 {cast.role}</p>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}